import React from 'react';

function casino() {
	return (
		<div class="col-md-10">
		  <div class="greeting">
				<img src={`${process.env.PUBLIC_URL}/images/panel2.png`} />
				<img src={`${process.env.PUBLIC_URL}/images/gdmobile.png`} />
				
		  </div>
		  <div class="casino">
			<h3>Table Game</h3>
			<a href="" class="game"><img src={`${process.env.PUBLIC_URL}/images/casino_game.png`} /></a>
			<a href="" class="game"><img src={`${process.env.PUBLIC_URL}/images/bigwin.png`} /></a>
		  </div>
		  <div class="casino">
			<h3>Slots</h3>
			<a href="" class="game"><img src={`${process.env.PUBLIC_URL}/images/slotcard.png`} /></a>
			<a href="" class="game"><img src={`${process.env.PUBLIC_URL}/images/slotspin.png`} /></a>
		  </div>
		</div>
	);
}

export default casino;
			